var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Slice',[_c('figure',{staticClass:"slice-visual"},[_c('b-img',{attrs:{"alt":_vm.slice.primary.visual.alt,"src":_vm.slice.primary.visual.url}}),_c('figcaption',[_vm._v(_vm._s(_vm.slice.primary.visual.alt))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }